export const PROVIDER = {
  student: 'students',
  tutor: 'tutors',
  teacher: 'teachers',
};
